import { render, staticRenderFns } from "./InfoLock.vue?vue&type=template&id=bb35f4cc&scoped=true"
import script from "./InfoLock.vue?vue&type=script&lang=js"
export * from "./InfoLock.vue?vue&type=script&lang=js"
import style0 from "./InfoLock.vue?vue&type=style&index=0&id=bb35f4cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb35f4cc",
  null
  
)

export default component.exports